<template>
  <div class="wrapper">
    <div class="inner" v-if="isShow">

      <div class="right-button"
          @click="clickBtn">{{rightButton}}</div>
      <div class="tabs-wrapper">
        <div
          v-for="(item, index) of tabList"
          :key="index"
          @click="clickSingle(item,index) "
          :class="['tab', tabSelectIndex === index ? 'tab-selected' : '']"
        >
          <div class="item-r">
            <div class="item-v">
              <span :class="['tabT', tabSelectItem === item ? 'tabT-selected' : '']">{{item}}</span>
              <div :class="['tabB', tabSelectItem === item ? 'tabB-selected' : '']"></div>
            </div>
          </div>
        </div>
      </div>
      <PeriodIncrease :fund-code="fundCode"
         ref="PeriodIncrease" class="innerview" v-if="tabSelectItem === '讨论'" />
      <NetList :fund-code="fundCode" ref="NetList" v-if="tabSelectItem === '问答'" />
    </div>
  </div>
</template>
<script>
import PeriodIncrease from '@/components/Fund-Comments.vue';
import NetList from '@/components/Fund-Question.vue';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
  userLogin,
} from '@/utils/nativeBridge';

export default {
  name: 'market',
  components: {
    PeriodIncrease,
    NetList,
  },
  props: {
    fundCode: {
      type: String,
      default: '',
    },
  },
  watch: {},
  data() {
    return {
      isShow: true,
      pageData: {},
      tabList: ['讨论', '问答'],
      tabSelectIndex: 0,
      tabSelectItem: '讨论',
      nativeData: {},
      // fundCode: '',
      fundType: '',
      pcData: {},
      rightButton: '我要发帖',
    };
  },
  computed: {
  },
  created() {
    this.handleDetail();
  },
  mounted() {},
  methods: {
    render() {
    },
    handleDetail() {
      this.handleData();
    },
    handleData() {
      // this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
    },
    clickSingle(item, index) {
      this.tabSelectItem = item;
      this.tabSelectIndex = index;
      if (item === '讨论') {
        this.rightButton = '我要发帖';
        // pz.jjtl.tab.click
        this.reportMonitor({
          eventName: 'pz.jjtl.tab.click',
        });
      } else {
        this.rightButton = '我要提问';
        // pz.jjtl.tab.click
        this.reportMonitor({
          eventName: 'pz.wd.tab.click',
        });
      }
    },
    clickBtn() {
      if (this.tabSelectItem === '讨论') {
        this.clickComment();
      } else {
        this.clickAsk();
      }
    },
    clickComment() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.ft.click', '');
      if (multi.$system.webPlatform === 'wxmp') {
        wx.miniProgram.navigateTo({
          url: '/pages/download/index', // 下载中间页
        });
        return;
      }
      detailPushPage({
        type: 1,
        isVerifyLogin: true,
        url: `fund://page/barPost?login=true&fundCode=${this.fundCode}`,
      });
      // this.reportMonitor({
      //   eventName: 'pz.xx.ft',
      //   infoCodeType: '5',
      //   infoCode: this.fundCode,
      // });
    },
    clickAsk() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.ft.click', '');
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        wx.miniProgram.navigateTo({
          url: '/pages/download/index', // 下载中间页
        });
        return;
      }
      // #if EXECUTION_ENV == 'web'
      if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        const baseInfo = StoreManger.getFundJJXQ();
        const name = StoreManger.getFundJJXQNAME(baseInfo);
        detailPushPage({
          type: 2,
          url: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarQuestPage?fundCode=${this.fundCode}&fundName=${name}`,
        });
        return;
      }
      // #endif
      userLogin().then(() => {
        this.askaction();
      }).catch(() => {

      });
      // this.reportMonitor({
      //   eventName: 'pz.xx.gk.tw',
      // });
    },
    askaction() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        type: 1,
        url: `fund://page/questionPost?fundcode=${this.fundCode}&fundname=${name}`,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper{
  // margin-left: 24px;
  // margin-right: 24px;
  margin-top: 24px;
  border-radius: 12px;
}
.inner {
  background-color: #ffffff;
  padding-bottom:10px;
  border-radius: 12px;
}
.tabs-wrapper {
  display: flex;
  height: 88px;
  border-radius: 12px;
}
.tip-icon-t {
  height: 24px;
  width: 24px;
  margin-left: 10px;
  padding-bottom: 0px;
}
.tab {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 30px;
}
.tab-selected {
  font-size: 36px;
  color: #000;
  font-weight: bold;
}
.tabT {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
}
.tabT-selected {
  font-size: 36px;
  color: #000;
  font-weight: bold;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tabB-selected {
  background-color:#ff4400;
}
.item-r{
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.item-v{
  position: relative;
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.right-button {
  position: absolute;
  right: 48px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border: 2px solid #008AFF;
  border-radius: 25px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  padding-top: 11px;
  padding-bottom: 11px;
  color: #008AFF;
  width: 160px;
  z-index: 1;
  margin-top: 30px;
}
</style>
